// Short lookup for service billing display labels.
// Used by ServiceCard, ServiceDetail, and Industries tier cards.
const LABELS = {
  monthly: { long: "Per month", short: "Monthly" },
  project: { long: "Per project", short: "Project" },
  custom: { long: "Custom scope", short: "Custom" },
};

const DEFAULT = { long: "One-time", short: "One-time" };

export const billingLabel = (billing, format = "short") =>
  (LABELS[billing] || DEFAULT)[format];
